import React from "react";
import InvestorLanding from "../components/componentsinvestors/InvestorLanding";
import InvestorTagline from "../components/componentsinvestors/InvestorTagline";
import Investor3thing from "../components/componentsinvestors/Investor3thing";
import InvestorBottomSection from "../components/componentsinvestors/InvestorBottomSection";

function Investors() {
  return (
    <div className="Investors">
      <InvestorLanding />
      <InvestorTagline />
      <Investor3thing />
      <InvestorBottomSection />
    </div>
  );
}

export default Investors;
